import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from './../axiosInstance.js';
import MyUserContext from './../myUserContext.js';
import { Button, Title, Paper, Stack, Text, Group, Badge } from '@mantine/core';
import { categoryOptions } from './ArtForm';

const adminId = '4312f009-7502-43a6-9483-2824508fe96f';

const ArtProposals = () => {
  const navigate = useNavigate();
  const myUser = useContext(MyUserContext);
  const isAdmin = myUser?.myUserInfo?.myUserId === adminId;

  const [proposals, setProposals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchProposals = async () => {
    try {
      const res = await axiosInstance.get('/artProposals');
      setProposals(res.data);
    } catch (err) {
      setError(err.response?.data || err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchProposals(); }, []);

  const handleDelete = async (id) => {
    try {
      await axiosInstance.delete(`/artProposals/${id}`);
      setProposals(prev => prev.filter(p => p.id !== id));
    } catch (err) {
      setError(err.response?.data || err.message);
    }
  };

  const categoryLabel = (cat) => categoryOptions.find(o => o.value === String(cat))?.label || 'Unknown';

  if (loading) return <div className="p-4"><Text>Loading...</Text></div>;

  return (
    <div className="max-w-2xl mx-auto p-4">
      <Group justify="space-between" mb="lg">
        <Title order={2}>Art Proposals</Title>
        <Button onClick={() => navigate('/createArtProposal')}>New Proposal</Button>
      </Group>

      {error && <Text c="red" mb="sm">{typeof error === 'string' ? error : JSON.stringify(error)}</Text>}

      {proposals.length === 0 ? (
        <Text c="dimmed">No proposals yet.</Text>
      ) : (
        <Stack gap="sm">
          {proposals.map(p => (
            <Paper key={p.id} p="md" withBorder>
              <Group justify="space-between" align="flex-start">
                <div style={{flex: 1}}>
                  <Group gap="xs" mb={4}>
                    <Text fw={600}>{p.name}</Text>
                    <Badge size="sm" variant="light">{categoryLabel(p.category)}</Badge>
                    {p.subCategory && <Badge size="sm" variant="outline">{p.subCategory}</Badge>}
                  </Group>
                  {p.ruName && <Text size="sm" c="dimmed">{p.ruName}</Text>}
                  {p.description && <Text size="sm" lineClamp={2} mt={4}>{p.description}</Text>}
                  {p.year > 0 && <Text size="xs" c="dimmed" mt={2}>Year: {p.year}</Text>}
                  {p.thumbnailUrl && (
                    <img src={p.thumbnailUrl} alt="" style={{maxHeight: 80, marginTop: 8, borderRadius: 4}} />
                  )}
                </div>
                <Stack gap={4}>
                  {isAdmin && (
                    <Button size="xs" color="green" onClick={() => navigate('/createArt', { state: { proposal: p } })}>
                      Create art
                    </Button>
                  )}
                  <Button size="xs" color="red" variant="outline" onClick={() => handleDelete(p.id)}>
                    Delete
                  </Button>
                </Stack>
              </Group>
            </Paper>
          ))}
        </Stack>
      )}
    </div>
  );
};

export default ArtProposals;
